




















































































































































































































































































import { isNullOrUndefined } from '@/functions';
import { http } from '@/services';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ContractsHome extends Vue {
  protected showNewContract: boolean = false;
  protected showDialog: boolean = false;
  protected showMenuStart: boolean = false;
  protected showMenuEnd: boolean = false;
  protected newContract = {
    startDate: new Date(Date.now()).toISOString().slice(0, 10),
    endDate: new Date(Date.now()).toISOString().slice(0, 10),
    packs: [],
    quantities: [],
    canBeOverused: [],
  };
  protected contracts: Array<any> = [];
  protected packages: Array<any> = [];
  protected breadcrumbItems: Array<any> = [
    { text: 'Empresas', exact: true, to: '/empresas', disabled: false },
    { text: 'Contratos', disabled: true},
  ];

  protected async mounted(): Promise<void> {
    this.contracts.push(...(await http.get(`/companies/${this.$route.params.id}/contracts`)).data);
    this.packages.push(...(await http.get(`/packages`)).data);
  }

  protected async changeStatus(contractId: number, contractStatus: string): Promise<void> {
    if (contractStatus === 'Ativo') {
      await http.delete(`/companies/${this.$route.params.id}/contracts/${contractId}`);
    } else {
      await http.post(`/companies/${this.$route.params.id}/contracts/${contractId}/reactivate`);
    }
    await this.reload();
  }

  protected async save(): Promise<void> {
    this.newContract.canBeOverused.forEach((value) => console.log(value));
    const data = {
      startDate: new Date(this.newContract.startDate),
      endDate: new Date(this.newContract.endDate),
      packs: new Array(this.newContract.packs.length),
    };
    this.newContract.packs.forEach((packId, index) => {
      data.packs[index] = {
        id: packId,
        quantity: this.newContract.quantities[index],
        canBeOverused: isNullOrUndefined(this.newContract.canBeOverused[index]) ? false : this.newContract.canBeOverused[index],
      };
    });
    await http.post(`/companies/${this.$route.params.id}/contracts`, data);
    this.showNewContract = false;
    await this.reload();
  }

  protected async reload(): Promise<void> {
    this.contracts.splice(0);
    this.contracts.push(...(await http.get(`/companies/${this.$route.params.id}/contracts`)).data);
    this.newContract = {
      startDate: new Date(Date.now()).toISOString().slice(0, 10),
        endDate: new Date(Date.now()).toISOString().slice(0, 10),
      packs: [],
      quantities: [],
      canBeOverused: [],
    };
    this.showDialog = true;
  }
}
